import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { connect } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization/utilization";

export default connect(
  (state) => ({
    filterType: "Custom Range",
    options: state.utilization.filters.class_values,
    selectedFilters: state.utilization.selectedClassFilters,
    placeholder: "Select Classes",
    selectAll: false,
    initFiltersLoaded: true,
    enableOnly: true,
    numberDisplayed: 0,
    includeSelectAll: true,
    displayCheckedOnly: true
  }),
  {
    updateLocations: (data) => actionCreators.updateDataByClass(data)
  }
)(MultiSelectDropdown);
